<template>
  <div class="online-content">
    <div class="mp3-home">
      <div class="mp3-title">
        <!-- <p>{{ title }}</p> -->
        <template v-if="titFrom == 'main'">
          <div class="video-tab-list">
            <p
              class="item"
              :class="{'cur': index == clickIndex}"
              v-for="(item, index) in navList"
              :key="index"
              @click="tabClassCode(index)"
            >{{ item.classcode_name }}</p>
          </div>
        </template>
        <template v-else>
          <p>{{ title }} {{ navList }}</p>
        </template>
        <em @click="bakToPrev" class="back_arrow"></em>
      </div>
      <div class="mp3-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mp3-home",
  props: ["title", "titFrom", "navList"],
  data: () => ({
    clickIndex: 0
  }),
  methods: {
    bakToPrev() {
      this.$emit("bakToPrev");
    },
    tabClassCode(i) {
      // if (i != this.clickIndex) {
      this.clickIndex = i;
      this.$emit("tabClassCode", this.navList[i].classcode_branch);
      // }
    }
  }
};
</script>
<style lang="less">
.mp3-home {
  height: 100%;
  border-radius: 20px;
  .mp3-title {
    height: 65px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #181818;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
    .back_arrow {
      width: 24px;
      height: 24px;
      background: url("../../assets/images/studyCenter/back-icon.png") center
        center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    
    .video-tab-list {
      display: flex;
      align-items: center;
      .item {
        margin-right: 20px;
        font-size: 16px;
        color: rgba(24, 24, 24, 1);
        line-height: 22px;
        cursor: pointer;
        &.cur {
          color: #ffcc02;
        }
      }
    }
  }
  .mp3-content {
    height: calc(100% - 65px);
    margin-top: 1px;
    background-color: #fff5ef;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
  }
}
</style>